export enum Pathnames {
  Logout = '/logout',
  OIDC = '/auth/oidc',
}
